module.exports = __webpack_public_path__ + "static/media/RPEX 9.eefb7097.mov";